import React, { useRef, useState } from 'react';

// 6-digit TOTP input with auto-advance between fields
const TOTPInput = ({ onComplete, disabled = false }) => {
  const [digits, setDigits] = useState(['', '', '', '', '', '']);
  const refs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()];

  const handleChange = (index, value) => {
    // Allow only single digit
    const digit = value.replace(/\D/g, '').slice(-1);
    const next = [...digits];
    next[index] = digit;
    setDigits(next);

    if (digit && index < 5) {
      refs[index + 1].current?.focus();
    }

    // Auto-submit when all 6 digits filled
    if (digit && index === 5) {
      const code = next.join('');
      if (code.length === 6) onComplete(code);
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !digits[index] && index > 0) {
      refs[index - 1].current?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    if (pasted.length === 6) {
      const next = pasted.split('');
      setDigits(next);
      refs[5].current?.focus();
      onComplete(pasted);
    }
  };

  return (
    <div className="flex gap-2 justify-center">
      {digits.map((digit, i) => (
        <input
          key={i}
          ref={refs[i]}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={digit}
          disabled={disabled}
          onChange={(e) => handleChange(i, e.target.value)}
          onKeyDown={(e) => handleKeyDown(i, e)}
          onPaste={i === 0 ? handlePaste : undefined}
          className="w-11 h-14 text-center text-2xl font-mono rounded-lg border-2
            border-border bg-card text-txt-primary focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20
            outline-none transition-all disabled:opacity-50"
          autoFocus={i === 0}
        />
      ))}
    </div>
  );
};

export default TOTPInput;
